import { Text } from "./Text";
import { Radio } from "./Radio";
import { Checkbox } from "./Checkbox";
import { Dropdown } from "./Dropdown";
import { DatePicker } from "./DatePicker";
import { Number } from "./Number";
import { Email } from "./Email";
import { Phone } from "./Phone";
import { YesNo } from "./YesNo";
import { Money } from "./Money";
import { Content } from "./Content";
import { FileUpload } from "./FileUpload";
import { Rating } from "./Rating";
import { Time } from "./Time";
import { ValidationSchema } from "@schema-types/types/JourneySchema";

export type FieldProps = {
  label?: string;
  name: string;
  required: boolean;
  validation?: ValidationSchema[];
  disabled?: boolean;
};

export const FieldComponents = {
  Text,
  Radio,
  Checkbox,
  Dropdown,
  DatePicker,
  Number,
  Email,
  Phone,
  Time,
  Rating,
  YesNo,
  Money,
  Content,
  FileUpload,
};
